export default {
  listCivilStatuss: [],
  civilStatus: {
    ativo: true,
    id: 0,
    nome: '',
  },
}
